import script from "./MapView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapView.vue?vue&type=script&lang=ts&setup=true"

import "./MapView.vue?vue&type=style&index=0&id=3d5e157a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5e157a"]])

export default __exports__